import styled from '@emotion/styled';

import { Variables } from 'styles/variables/variables';
import type { Agent } from 'types';

const tableFont = `
    font-family: ${Variables.assistant};
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    color: #282828;
`;

export const Container = styled.div`
    display: inline-block;
    position: relative;
    width: 130px;
    overflow: hidden;
    whitespace: nowrap;
    textoverflow: ellipsis;
`;

export const Button = styled.button`
    ${tableFont}
    cursor: pointer;
    width: 220px;
    display: flex;
    gap: 4px;
    align-items: center;
    width: 100%;
    alignitems: center;
    overflow: hidden;
    whitespace: nowrap;
    textoverflow: ellipsis;
    minwidth: 0;
    border: none;
    background: transparent;
    padding: 0;
    &:hover {
        padding: 0 4px 0 6px;
        background-color: lightgray !important;
        border-radius: 10px;
    }
`;

export const PortalDropdown = styled.div`
    position: absolute;
    background: white;
    border: 1px solid #d1fae5;
    border-radius: 8px;
    width: 220px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
    z-index: 1400;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    ${tableFont}
`;

export const SearchInput = styled.input`
    border: none;
    border-bottom: 1px solid #e5e7eb;
    padding: 8px 10px;
    font-family: ${Variables.assistant};
    font-size: 16px;
    line-height: 20px;
    outline: none;
    color: #282828;
    background: white;

    &::placeholder {
        color: #9ca3af;
    }

    &:focus {
        border-bottom-color: #6d41d8;
    }
`;

export const DropdownList = styled.div`
    max-height: 150px;
    overflow-y: auto;
`;

export const EmptyState = styled.div`
    padding: 8px 10px;
    color: #6b7280;
    font-family: ${Variables.assistant};
    font-size: 16px;
    line-height: 20px;
    text-align: center;
`;

export const DropdownItem = styled.div`
    padding: 4px 6px;
    cursor: pointer;
    background-color: white;
    ${tableFont}

    &:hover {
        background-color: #f5f5f5;
    }
`;

export const Text = styled.span<{ data: Agent | null }>`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    minwidth: 0;
    flexshrink: 1;
    margin: ${({ data }) => (data ? 'unset' : 'auto')};
`;

export const ArrowIcon = styled.div<{ open: boolean }>`
    width: 0;
    height: 0;
    margin-left: 8px;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: ${({ open }) => (open ? '0' : '6px')} solid black;
    border-bottom: ${({ open }) => (open ? '6px' : '0')} solid black;
    transition: transform 0.2s ease;
`;
